import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import { PriceHistoryPanel } from "@/components/PriceHistoryPanel/PriceHistoryPanel";
import { useHtmlifiedTranslations } from "@/services/useHtmlifiedTranslations";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxPricePanel = ({ dashboard, location, channel, language, externalId }: FundDetailLayoutComponentProps) => {
	const { fxPricePanel: props, fxDefinitionListGroupPanel, translations: encodedTranslations } = dashboard;
	const translations = useHtmlifiedTranslations(encodedTranslations);

	if (!props) {
		return null;
	}

	return (
		<ContentBlock id="fxPricePanel" data-testid="FxPricePanel" tabIndex={-1}>
			<PriceHistoryPanel
				downloadPriceModal={fxDefinitionListGroupPanel?.downloadPriceModal}
				{...props}
				location={location}
				channel={channel}
				language={language}
				externalId={externalId}
				translations={translations}
			/>
		</ContentBlock>
	);
};
